"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputDebounceComponent = void 0;
const core_1 = require("@angular/core");
const Rx_1 = require("rxjs/Rx");
let InputDebounceComponent = class InputDebounceComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.delay = 300;
        this.klass = "form-control";
        this.value = new core_1.EventEmitter();
        const eventStream = Rx_1.Observable.fromEvent(elementRef.nativeElement, 'keyup')
            .map(() => this.inputValue)
            .debounceTime(this.delay)
            .distinctUntilChanged();
        eventStream.subscribe(input => this.value.emit(input));
    }
};
exports.InputDebounceComponent = InputDebounceComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], InputDebounceComponent.prototype, "placeholder", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Number)
], InputDebounceComponent.prototype, "delay", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], InputDebounceComponent.prototype, "klass", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], InputDebounceComponent.prototype, "value", void 0);
exports.InputDebounceComponent = InputDebounceComponent = __decorate([
    (0, core_1.Component)({
        selector: 'input-debounce',
        template: '<input type="text" [ngClass]="klass" [placeholder]="placeholder" [(ngModel)]="inputValue">'
    }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], InputDebounceComponent);
//# sourceMappingURL=input-debounce.js.map